import {makeStyles} from '@material-ui/core/styles';
import React, {useState, useEffect} from 'react';
import globalContext from '../../../config/context';
import socket from '../../../config/socket';
import Api from '../../../config/api';
import swal from 'sweetalert';
import domtoimage from 'dom-to-image';
import download from 'downloadjs';
import {v4 as uuidv4} from 'uuid';
import L from 'leaflet';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const useHook = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [
    {
      refreshLegend,
      pencarian,
      loading,
      checkedPbb,
      checkedBphtb,
      checkedHotel,
      checkedRestoran,
      checkedHiburan,
      checkedReklame,
      checkedPpj,
      checkedMblb,
      checkedParkir,
      checkedPat,
      checkedWalet,
      checkedPendataan,
      centroidLatitude,
      centroidLongitude,
      targetPendataan,
      zoomKelurahan,
      zoomBlok,
      zoomPersil,
    },
    {
      setRefreshLegend,
      setPencarian,
      setLoading,
      setCheckedPbb,
      setCheckedBphtb,
      setCheckedHotel,
      setCheckedRestoran,
      setCheckedHiburan,
      setCheckedReklame,
      setCheckedPpj,
      setCheckedMblb,
      setCheckedParkir,
      setCheckedPat,
      setCheckedWalet,
      setCheckedPendataan,
      setCentroidLatitude,
      setCentroidLongitude,
      setTargetPendataan,
      setZoomKelurahan,
      setZoomBlok,
      setZoomPersil,
    },
  ] = useAppContext();

  const {
    drawer,
    setDrawer,
    mapRef,
    getKelurahan,
    getBlok,
    getPersil,
    getZnt,
    markerPbbRefGeoJson,
    getMarkerPbb,
    markerBphtbRefGeoJson,
    getMarkerBphtb,
    markerHotelRefGeoJson,
    getMarkerHotel,
    markerRestoranRefGeoJson,
    getMarkerRestoran,
    markerHiburanRefGeoJson,
    getMarkerHiburan,
    markerReklameRefGeoJson,
    getMarkerReklame,
    markerPpjRefGeoJson,
    getMarkerPpj,
    markerMblbRefGeoJson,
    getMarkerMblb,
    markerParkirRefGeoJson,
    getMarkerParkir,
    markerPatRefGeoJson,
    getMarkerPat,
    markerWaletRefGeoJson,
    getMarkerWalet,
    markerPendataanRefGeoJson,
    getMarkerPendataan,
    setInputNop,
    latitude,
    longitude,
    setLatitude,
    setLongitude,
  } = props;
  const [tahun, setTahun] = useState(null);
  const [map, setMap] = useState(null);

  useEffect(() => {
    getTitikPusat();
    getTarget();
    getZoom();
    getWarna();
    if (mapRef) {
      setMap(mapRef.current.leafletElement);
    }
  }, [mapRef]);

  //dialog Zona Nilai Tanah----------------------------------------------------------------------------------------------------------
  const [znt, setZnt] = useState(false);
  const handleClickZnt = () => {
    setZnt(true);
  };
  const handleCloseZnt = () => {
    setZnt(false);
  };

  //dialog Sebaran ZNT----------------------------------------------------------------------------------------------------------
  const [sebaranZnt, setSebaranZnt] = useState(false);
  const handleClickSebaranZnt = () => {
    setSebaranZnt(true);
  };
  const handleCloseSebaranZnt = () => {
    setSebaranZnt(false);
  };

  //dialog Ketetapan PBB------------------------------------------------------------------------------------------------
  const [ketetapanPbb, setKetetapanPbb] = useState(false);
  const handleClickKetetapanPbb = () => {
    setKetetapanPbb(true);
  };
  const handleCloseKetetapanPbb = () => {
    setKetetapanPbb(false);
  };

  //dialog Status Pembayaran--------------------------------------------------------------------------------------------
  const [statusPembayaran, setStatusPembayaran] = useState(false);
  const handleClickStatusPembayaran = () => {
    setStatusPembayaran(true);
  };
  const handleCloseStatusPembayaran = () => {
    setStatusPembayaran(false);
  };

  //dialog Pencarian Nama--------------------------------------------------------------------------------------------
  const [cariNama, setCariNama] = useState(false);
  const handleClickCariNama = () => {
    setCariNama(true);
  };
  const handleCloseCariNama = () => {
    setCariNama(false);
  };

  //dialog Pencarian Alamat--------------------------------------------------------------------------------------------
  const [cariAlamat, setCariAlamat] = useState(false);
  const handleClickCariAlamat = () => {
    setCariAlamat(true);
  };
  const handleCloseCariAlamat = () => {
    setCariAlamat(false);
  };

  //dialog Pencarian Blok--------------------------------------------------------------------------------------------
  const [cariBlok, setCariBlok] = useState(false);
  const handleClickCariBlok = () => {
    setCariBlok(true);
  };
  const handleCloseCariBlok = () => {
    setCariBlok(false);
  };

  //dialog Pencarian Koordinat--------------------------------------------------------------------------------------------
  const [cariKoordinat, setCariKoordinat] = useState(false);
  const handleClickCariKoordinat = () => {
    setCariKoordinat(true);
  };
  const handleCloseCariKoordinat = () => {
    setCariKoordinat(false);
  };

  //dialog Custom----------------------------------------------------------------------------------------------------------
  const [custom, setCustom] = useState(false);
  const handleClickCustom = () => {
    setCustom(true);
  };
  const handleCloseCustom = () => {
    setCustom(false);
  };

  //dialog Upload Foto--------------------------------------------------------------------------------------------------
  const [uploadFoto, setUploadFoto] = React.useState(false);
  const handleClickUploadFoto = () => {
    setUploadFoto(true);
  };
  const handleCloseUploadFoto = () => {
    setUploadFoto(false);
  };

  //dialog Upload Kelurahan---------------------------------------------------------------------------------------------
  const [uploadKelurahan, setUploadKelurahan] = React.useState(false);
  const handleClickUploadKelurahan = () => {
    setUploadKelurahan(true);
  };
  const handleCloseUploadKelurahan = () => {
    setUploadKelurahan(false);
  };

  //dialog Upload Blok--------------------------------------------------------------------------------------------------
  const [uploadBlok, setUploadBlok] = React.useState(false);
  const handleClickUploadBlok = () => {
    setUploadBlok(true);
  };
  const handleCloseUploadBlok = () => {
    setUploadBlok(false);
  };

  //dialog Upload Persil-----------------------------------------------------------------------------------------------
  const [uploadPersil, setUploadPersil] = React.useState(false);
  const handleClickUploadPersil = () => {
    setUploadPersil(true);
  };
  const handleCloseUploadPersil = () => {
    setUploadPersil(false);
  };

  //dialog Upload ZNT-----------------------------------------------------------------------------------------------
  const [uploadZnt, setUploadZnt] = React.useState(false);
  const handleClickUploadZnt = () => {
    setUploadZnt(true);
  };
  const handleCloseUploadZnt = () => {
    setUploadZnt(false);
  };

  //select Kecamatan----------------------------------------------------------------------------------------------------
  const [kecamatan, setKecamatan] = useState('');
  const [kecamatanOptions, setKecamatanOptions] = useState('');
  const handleKecamatan = (event, value) => {
    // setKecamatan(event.target.value); -- FormControl
    setKecamatan(value ? value.kd_kecamatan : '');
    setKecamatanOptions(value);
  };
  const [itemKecamatan, setItemKecamatan] = useState([]);
  useEffect(() => {
    Api.get('gis/ref/kecamatan').then(function (response) {
      if (response) {
        if (response.data) {
          setItemKecamatan(response.data);
        }
      }
    });
  }, []);

  useEffect(() => {
    Api.get('gis/ref/kecamatan').then(function (response) {
      if (response) {
        if (response.data) {
          for (const item of response.data) {
            if (String(item.kd_kecamatan) === String(kecamatan)) {
              setKecamatanOptions(item);
            }
          }
        }
      }
    });
  }, [kecamatan]);

  //select Kelurahan----------------------------------------------------------------------------------------------------
  const [kelurahan, setKelurahan] = useState('');
  const [kelurahanOptions, setKelurahanOptions] = useState('');
  const handleKelurahan = (event, value) => {
    // setKelurahan(event.target.value); -- FormControl
    setKelurahan(value ? value.kd_kelurahan : '');
    setKelurahanOptions(value);
  };

  const [itemKelurahan, setItemKelurahan] = useState([]);
  useEffect(() => {
    Api.get('gis/ref/kelurahan', {
      kec: kecamatan ? kecamatan : '0',
    }).then(function (response) {
      // console.log(response)
      if (response) {
        if (response.data) {
          setItemKelurahan(response.data);
        }
      }
    });
  }, [kecamatan]);

  useEffect(() => {
    Api.get('gis/ref/kelurahan', {
      kec: kecamatan ? kecamatan : '0',
    }).then(function (response) {
      // console.log(response)
      if (response) {
        if (response.data) {
          for (const item of response.data) {
            if (String(item.kd_kelurahan) === String(kelurahan)) {
              setKelurahanOptions(item);
            }
          }
        }
      }
    });
  }, [kelurahan]);

  //select Blok---------------------------------------------------------------------------------------------------------
  const [blok, setBlok] = useState('');
  const [blokOptions, setBlokOptions] = useState('');
  const handleBlok = (event, value) => {
    // setBlok(event.target.value);  --FormControl
    setBlok(value ? value.kd_blok : '');
    setBlokOptions(value);
  };

  const [itemBlok, setItemBlok] = useState([]);
  useEffect(() => {
    Api.get('gis/ref/blok', {
      kec: kecamatan ? kecamatan : '0',
      kel: kelurahan ? kelurahan : '0',
    }).then(function (response) {
      // console.log(response)
      if (response) {
        if (response.data) {
          setItemBlok(response.data);
        }
      }
    });
  }, [kelurahan]);

  useEffect(() => {
    Api.get('gis/ref/blok', {
      kec: kecamatan ? kecamatan : '0',
      kel: kelurahan ? kelurahan : '0',
    }).then(function (response) {
      // console.log(response)
      if (response) {
        if (response.data) {
          for (const item of response.data) {
            if (String(item.kd_blok) === String(blok)) {
              setBlokOptions(item);
            }
          }
        }
      }
    });
  }, [blok]);

  //Tematik ZNT---------------------------------------------------------------------------------------------------
  const onZnt = () => {
    setDrawer(false);

    let kec = kecamatan ? kecamatan : pencarian.kecamatan;
    let kel = kelurahan ? kelurahan : pencarian.kelurahan;

    Api.get('gis/search/znt', {
      kec: kec,
      kel: kel,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          // Set State Peta Temamik
          const tmp = {
            ...pencarian,
            state: 'znt',
            tahun: tahun ? tahun : pencarian.tahun,
            kecamatan: kecamatan ? kecamatan : pencarian.kecamatan,
            kelurahan: kelurahan ? kelurahan : pencarian.kelurahan,
            blok: '',
          };
          setPencarian(tmp);
          map.panTo(new L.LatLng(response.data.latitude, response.data.longitude));
          if (map.getZoom() >= zoomBlok) {
            setTimeout(() => {
              map.setZoom(zoomBlok);
              getZnt(tmp);
            }, 500);
          } else {
            setTimeout(() => {
              map.setZoom(zoomBlok);
            }, 500);
          }
        }
      }
    });
  };

  //Tematik Blok Peta---------------------------------------------------------------------------------------------------
  const onDefault = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'default',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Sebaran ZNT--------------------------------------------------------------------------------------------
  const onSebaranZnt = () => {
    setDrawer(false);

    let kec = kecamatan ? kecamatan : pencarian.kecamatan;
    let kel = kelurahan ? kelurahan : pencarian.kelurahan;

    Api.get('gis/search/sebaran_znt', {
      kec: kec,
      kel: kel,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          // Set State Peta Temamik
          const tmp = {
            ...pencarian,
            state: 'sebaran_znt',
            tahun: tahun ? tahun : pencarian.tahun,
            kecamatan: kecamatan ? kecamatan : pencarian.kecamatan,
            kelurahan: kelurahan ? kelurahan : pencarian.kelurahan,
            blok: '',
          };
          setPencarian(tmp);
          map.panTo(new L.LatLng(response.data.latitude, response.data.longitude));
          if (map.getZoom() >= zoomPersil) {
            setTimeout(() => {
              map.setZoom(zoomPersil);
              getPersil(tmp);
            }, 500);
          } else {
            setTimeout(() => {
              map.setZoom(zoomPersil);
            }, 500);
          }
        }
      }
    });
  };

  //Tematik Pengelompokan Ketetapan PBB---------------------------------------------------------------------------------
  const onKetetapanPbb = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'ketetapan_pbb',
      tahun: tahun ? tahun : pencarian.tahun,
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Objek yang dinilai secara Individu--------------------------------------------------------------------------
  const onObjekIndividu = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'nilai_individu',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Jenis Tanah-------------------------------------------------------------------------------------
  const onJenisTanah = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'jenis_tanah',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Jenis Bangunan-------------------------------------------------------------------------------------
  const onJenisBangunan = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'jenis_bangunan',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Jenis Tanah-------------------------------------------------------------------------------------
  const onKelasTanah = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'kelas_tanah',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Jenis Tanah-------------------------------------------------------------------------------------
  const onKelasBangunan = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'kelas_bangunan',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Status Pendaftaran Pajak-------------------------------------------------------------------------------------
  const onStatusPendaftaran = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'status_pendaftaran',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Status Pembayaran Pajak-------------------------------------------------------------------------------------
  const onStatusPembayaran = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'status_pembayaran',
      tahun: tahun ? tahun : pencarian.tahun,
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Status Tunggakan Pajak-------------------------------------------------------------------------------------
  const onStatusTunggakan = () => {
    setDrawer(false);
    setLoading(true);

    // Set State Peta Temamik
    const tmp = {
      ...pencarian,
      state: 'status_tunggakan',
      tahun: '',
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    map.setZoom(zoomPersil);
    getPersil(tmp);
  };

  //Tematik Pbb-------------------------------------------------------------------------------------------------------
  const mapZoom = mapRef.current.leafletElement;
  const zoomLevel = mapZoom.getZoom();
  const onPbb = () => {
    if (!checkedPbb) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerPbb();
      }
    } else {
      markerPbbRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedPbb((e) => !e);
  };

  //Tematik Bphtb-------------------------------------------------------------------------------------------------------
  const onBphtb = () => {
    if (!checkedBphtb) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerBphtb();
      }
    } else {
      markerBphtbRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedBphtb((e) => !e);
  };

  //Tematik  Hotel-------------------------------------------------------------------------------------------------------
  const onHotel = () => {
    if (!checkedHotel) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerHotel();
      }
    } else {
      markerHotelRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedHotel((e) => !e);
  };

  //Tematik  Restoran-------------------------------------------------------------------------------------------------------
  const onRestoran = () => {
    if (!checkedRestoran) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerRestoran();
      }
    } else {
      markerRestoranRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedRestoran((e) => !e);
  };

  //Tematik  Hiburan-------------------------------------------------------------------------------------------------------
  const onHiburan = () => {
    if (!checkedHiburan) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerHiburan();
      }
    } else {
      markerHiburanRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedHiburan((e) => !e);
  };

  //Tematik  Reklame-------------------------------------------------------------------------------------------------------
  const onReklame = () => {
    if (!checkedReklame) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerReklame();
      }
      getMarkerReklame();
    } else {
      markerReklameRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedReklame((e) => !e);
  };

  //Tematik  Ppj-------------------------------------------------------------------------------------------------------
  const onPpj = () => {
    if (!checkedPpj) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerPpj();
      }
    } else {
      markerPpjRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedPpj((e) => !e);
  };

  //Tematik  Parkir-------------------------------------------------------------------------------------------------------
  const onParkir = () => {
    if (!checkedParkir) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerParkir();
      }
    } else {
      markerParkirRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedParkir((e) => !e);
  };

  //Tematik  Pat-------------------------------------------------------------------------------------------------------
  const onPat = () => {
    if (!checkedPat) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerPat();
      }
    } else {
      markerPatRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedPat((e) => !e);
  };

  //Tematik  Walet-------------------------------------------------------------------------------------------------------
  const onWalet = () => {
    if (!checkedWalet) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerWalet();
      }
    } else {
      markerWaletRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedWalet((e) => !e);
  };

  //Tematik  Mblb-------------------------------------------------------------------------------------------------------
  const onMblb = () => {
    if (!checkedMblb) {
      // setDrawer(false);
      if (zoomLevel >= zoomPersil) {
        setLoading(true);
        getMarkerMblb();
      }
    } else {
      markerMblbRefGeoJson.current.leafletElement.clearLayers();
      // setDrawer(false);
    }
    setCheckedMblb((e) => !e);
  };

  //Tematik Pendataan----------------------------------------------------------------------------------------------------
  const onPendataan = () => {
    setDrawer(false);
    setLoading(true);
    getMarkerPendataan();
  };

  //Pencarian Nama-------------------------------------------------------------------------------------------------------
  const [nama, setNama] = useState('');
  const [listNama, setListNama] = useState([]);
  const onCariNama = (nop) => {
    handleCloseCariNama();
    setDrawer(false);
    setTimeout(() => {
      setInputNop(nop);
    }, 100);
  };
  const onCariNamaButton = () => {
    Api.get('gis/search/nama', {nama}).then(function (response) {
      if (response) {
        if (response.data) {
          setListNama(response.data);
        }
      }
    });
  };

  const handlePressCariNama = (event) => {
    // console.log(event.keyCode);
    if (event.keyCode === 13) {
      // console.log('enter press here! ');
      onCariNamaButton();
    }
  };

  //Pencarian Alamat-------------------------------------------------------------------------------------------------------
  const [alamat, setAlamat] = useState('');
  const [listAlamat, setListAlamat] = useState([]);
  const onCariAlamat = (nop) => {
    handleCloseCariAlamat();
    setDrawer(false);
    setTimeout(() => {
      setInputNop(nop);
    }, 100);
  };
  const onCariAlamatButton = () => {
    Api.get('gis/search/alamat', {alamat}).then(function (response) {
      if (response) {
        if (response.data) {
          setListAlamat(response.data);
        }
      }
    });
  };

  const handlePressCariAlamat = (event) => {
    // console.log(event.keyCode);
    if (event.keyCode === 13) {
      // console.log('enter press here! ');
      onCariAlamatButton();
    }
  };

  //Pencarian Blok------------------------------------------------------------------------------------------------------
  const onCariBlok = () => {
    setDrawer(false);

    let kec = kecamatan ? kecamatan : pencarian.kecamatan;
    let kel = kelurahan ? kelurahan : pencarian.kelurahan;
    let blokCari = blok ? blok : pencarian.blok;

    Api.get('gis/search/blok', {
      kec: kec,
      kel: kel,
      blok: blokCari,
    }).then(function (response) {
      if (response) {
        if (response.data) {
          const tmp = {
            ...pencarian,
            kecamatan: kecamatan ? kecamatan : pencarian.kecamatan,
            kelurahan: kelurahan ? kelurahan : pencarian.kelurahan,
            blok: blok ? blok : pencarian.blok,
          };
          setPencarian(tmp);
          map.panTo(new L.LatLng(response.data.latitude, response.data.longitude));
          if (map.getZoom() >= zoomBlok) {
            setTimeout(() => {
              map.setZoom(zoomBlok);
              getBlok(tmp);
            }, 500);
          } else {
            setTimeout(() => {
              map.setZoom(zoomBlok);
            }, 500);
          }
        }
      }
    });
  };

  const onResetBlok = () => {
    setDrawer(false);
    const tmp = {
      ...pencarian,
      kecamatan: '',
      kelurahan: '',
      blok: '',
    };
    setPencarian(tmp);
    getBlok(tmp);
  };

  //Pencarian Koordinat------------------------------------------------------------------------------------------------------
  const onCariKoordinat = () => {
    setDrawer(false);

    map.panTo(new L.LatLng(latitude, longitude));
    if (map.getZoom() >= zoomPersil) {
      setTimeout(() => {
        map.setZoom(zoomPersil);
      }, 500);
    } else if (map.getZoom() >= zoomBlok && map.getZoom() < zoomPersil) {
      setTimeout(() => {
        map.setZoom(zoomBlok);
      }, 500);
    } else if (map.getZoom() >= zoomKelurahan && map.getZoom() < zoomBlok) {
      setTimeout(() => {
        map.setZoom(zoomKelurahan);
      }, 500);
    } else {
      setTimeout(() => {
        map.setZoom(zoomKelurahan);
      }, 500);
    }
  };

  const onResetKoordinat = () => {
    setDrawer(false);
    setLatitude('');
    setLongitude('');
  };
  //Custom Maps-------------------------------------------------------------------------------------------------------
  const onCustom = () => {
    handleCloseCustom();
    setDrawer(false);
  };

  //Upload Foto Objek--------------------------------------------------------------------------------------------
  const onUploadFoto = (images) => {
    // console.log(images);
    const data = new FormData();
    for (const item of images) {
      data.append('fotoObjek', item);
    }

    Api.post('gis/upload/upload_foto', data, true)
      .then(function (response) {
        if (response) {
          if (response.data) {
            swal({
              title: 'Upload Berhasil',
              text: null,
              icon: 'success',
              button: 'close',
            });
          } else {
            swal({
              title: 'Upload Gagal',
              text: response.err,
              icon: 'error',
              button: 'close',
            });
          }
        } else {
          swal({
            title: null,
            text: 'Lengkapi file upload terlebih dahulu',
            icon: 'info',
            button: 'close',
          });
        }
      })
      .finally(function () {
        handleCloseUploadFoto();
        setDrawer(false);
      });
    handleCloseUploadFoto();
    setDrawer(false);
  };

  //Upload GeoJSON Kelurahan--------------------------------------------------------------------------------------------
  const [shpKelurahan, setShpKelurahan] = useState(null);
  const shpKelurahanHandler = (event) => {
    // console.log(event.target.files[0])
    setShpKelurahan(event.target.files[0]);
  };

  const [shxKelurahan, setShxKelurahan] = useState(null);
  const shxKelurahanHandler = (event) => {
    // console.log(event.target.files[0])
    setShxKelurahan(event.target.files[0]);
  };

  const [dbfKelurahan, setDbfKelurahan] = useState(null);
  const dbfKelurahanHandler = (event) => {
    // console.log(event.target.files[0])
    setDbfKelurahan(event.target.files[0]);
  };

  const [progressKelurahan, setProgressKelurahan] = React.useState(0);

  const onUploadKelurahan = () => {
    const data = new FormData();
    const id = uuidv4();

    data.append('shp', shpKelurahan);
    data.append('shx', shxKelurahan);
    data.append('dbf', dbfKelurahan);
    //--------------------------------
    data.append('kec', kecamatan);
    data.append('id', id);

    //Get Persen Upload----------------------------------------
    socket({id: id}).then((io) => {
      io.on('persen', (msg) => {
        if (msg) {
          setProgressKelurahan(msg);
        }
      });

      io.on('error', (msg) => {
        console.info(msg);
      });
    });

    Api.post('gis/upload/upload_kelurahan', data, true)
      .then(function (response) {
        if (response) {
          if (response.data) {
            swal({
              title: 'Upload Berhasil',
              text: null,
              icon: 'success',
              button: 'close',
            });
          } else {
            swal({
              title: 'Upload Gagal',
              text: response.error,
              icon: 'error',
              button: 'close',
            });
          }
        } else {
          swal({
            title: null,
            text: 'Lengkapi file upload terlebih dahulu',
            icon: 'info',
            button: 'close',
          });
        }
      })
      .finally(function () {
        handleCloseUploadKelurahan();
        setDrawer(false);
      });
  };

  //Upload GeoJSON Blok-------------------------------------------------------------------------------------------------
  const [shpBlok, setShpBlok] = useState(null);
  const shpBlokHandler = (event) => {
    // console.log(event.target.files[0])
    setShpBlok(event.target.files[0]);
  };

  const [shxBlok, setShxBlok] = useState(null);
  const shxBlokHandler = (event) => {
    // console.log(event.target.files[0])
    setShxBlok(event.target.files[0]);
  };

  const [dbfBlok, setDbfBlok] = useState(null);
  const dbfBlokHandler = (event) => {
    // console.log(event.target.files[0])
    setDbfBlok(event.target.files[0]);
  };

  const [progressBlok, setProgressBlok] = React.useState(0);

  const onUploadBlok = () => {
    const data = new FormData();
    const id = uuidv4();

    data.append('shp', shpBlok);
    data.append('shx', shxBlok);
    data.append('dbf', dbfBlok);
    //--------------------------------
    data.append('kec', kecamatan);
    data.append('kel', kelurahan);
    data.append('id', id);

    //Get Persen Upload-------------------------------------
    socket({id: id}).then((io) => {
      io.on('persen', (msg) => {
        if (msg) {
          setProgressBlok(msg);
        }
      });

      io.on('error', (msg) => {
        console.info(msg);
      });
    });

    Api.post('gis/upload/upload_blok', data, true)
      .then(function (response) {
        if (response) {
          if (response.data) {
            swal({
              title: 'Upload Berhasil',
              text: null,
              icon: 'success',
              button: 'close',
            });
          } else {
            swal({
              title: 'Upload Gagal',
              text: response.error,
              icon: 'error',
              button: 'close',
            });
          }
        } else {
          swal({
            title: null,
            text: 'Lengkapi file upload terlebih dahulu',
            icon: 'info',
            button: 'close',
          });
        }
      })
      .finally(function () {
        handleCloseUploadBlok();
        setDrawer(false);
      });
  };

  //Upload GeoJSON Persil-----------------------------------------------------------------------------------------------
  const [shpPersil, setShpPersil] = useState(null);
  const shpPersilHandler = (event) => {
    // console.log(event.target.files[0])
    setShpPersil(event.target.files[0]);
  };

  const [shxPersil, setShxPersil] = useState(null);
  const shxPersilHandler = (event) => {
    // console.log(event.target.files[0])
    setShxPersil(event.target.files[0]);
  };

  const [dbfPersil, setDbfPersil] = useState(null);
  const dbfPersilHandler = (event) => {
    // console.log(event.target.files[0])
    setDbfPersil(event.target.files[0]);
  };

  const [progressPersil, setProgressPersil] = React.useState(0);

  const onUploadPersil = () => {
    const data = new FormData();
    const id = uuidv4();

    data.append('shp', shpPersil);
    data.append('shx', shxPersil);
    data.append('dbf', dbfPersil);
    //--------------------------------
    data.append('kec', kecamatan);
    data.append('kel', kelurahan);
    data.append('id', id);

    //Get Persen Upload--------------------------------------------------
    socket({id: id}).then((io) => {
      io.on('persen', (msg) => {
        if (msg) {
          setProgressPersil(msg);
        }
      });

      io.on('error', (msg) => {
        console.info(msg);
      });
    });

    Api.post('gis/upload/upload_persil', data, true)
      .then(function (response) {
        if (response) {
          if (response.data) {
            swal({
              title: 'Upload Berhasil',
              text: null,
              icon: 'success',
              button: 'close',
            });
          } else {
            swal({
              title: 'Upload Gagal',
              text: response.error,
              icon: 'error',
              button: 'close',
            });
          }
        } else {
          swal({
            title: null,
            text: 'Lengkapi file upload terlebih dahulu',
            icon: 'info',
            button: 'close',
          });
        }
      })
      .finally(function () {
        handleCloseUploadPersil();
        setDrawer(false);
      });
  };

  //Upload GeoJSON ZNT-------------------------------------------------------------------------------------------------
  const [shpZnt, setShpZnt] = useState(null);
  const shpZntHandler = (event) => {
    // console.log(event.target.files[0])
    setShpZnt(event.target.files[0]);
  };

  const [shxZnt, setShxZnt] = useState(null);
  const shxZntHandler = (event) => {
    // console.log(event.target.files[0])
    setShxZnt(event.target.files[0]);
  };

  const [dbfZnt, setDbfZnt] = useState(null);
  const dbfZntHandler = (event) => {
    // console.log(event.target.files[0])
    setDbfZnt(event.target.files[0]);
  };

  const [progressZnt, setProgressZnt] = React.useState(0);

  const onUploadZnt = () => {
    const data = new FormData();
    const id = uuidv4();

    data.append('shp', shpZnt);
    data.append('shx', shxZnt);
    data.append('dbf', dbfZnt);
    //--------------------------------
    data.append('kec', kecamatan);
    data.append('kel', kelurahan);
    data.append('id', id);

    //Get Persen Upload-------------------------------------
    socket({id: id}).then((io) => {
      io.on('persen', (msg) => {
        if (msg) {
          setProgressZnt(msg);
        }
      });

      io.on('error', (msg) => {
        console.info(msg);
      });
    });

    Api.post('gis/upload/upload_Znt', data, true)
      .then(function (response) {
        if (response) {
          if (response.data) {
            swal({
              title: 'Upload Berhasil',
              text: null,
              icon: 'success',
              button: 'close',
            });
          } else {
            swal({
              title: 'Upload Gagal',
              text: response.error,
              icon: 'error',
              button: 'close',
            });
          }
        } else {
          swal({
            title: null,
            text: 'Lengkapi file upload terlebih dahulu',
            icon: 'info',
            button: 'close',
          });
        }
      })
      .finally(function () {
        handleCloseUploadZnt();
        setDrawer(false);
      });
  };

  //Print---------------------------------------------------------------------------------------------------------------
  const onPrint = () => {
    setDrawer(false);
    const node = document.getElementById('printMap');
    // console.log(node);
    domtoimage
      .toPng(node)
      .then(function (dataUrl) {
        if (dataUrl) {
          download(dataUrl, 'GIS', 'png');
        }
      })
      .catch(function (error) {
        swal({
          title: String(error),
          text: null,
          icon: 'error',
          button: 'close',
        });
      });
  };

  //Pengaturan Titik Pusat----------------------------------------------------------------------------------------------------
  const [stateTitik, setStateTitik] = useState(false);
  const handleClickTitikPusat = () => {
    setStateTitik(true);
  };
  const handleCloseTitikPusat = () => {
    setStateTitik(false);
  };

  const getTitikPusat = () => {
    // setLoading(true);
    Api.get('gis/settings/get_titik')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          setCentroidLatitude(response.data[0].latitude);
          setCentroidLongitude(response.data[0].longitude);
        }
      })
      .finally(function () {
        // setLoading(false);
      });
  };

  const onTitikPusat = () => {
    // setLoading(true);
    Api.post('gis/settings/save_titik', {
      centroidLatitude,
      centroidLongitude,
    }).finally(function () {
      // setLoading(false);
      setDrawer(false);
      swal({
        title: 'Save Berhasil',
        text: null,
        icon: 'success',
        button: 'close',
      });
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  //Pengaturan Titik Pusat----------------------------------------------------------------------------------------------------
  const [stateTarget, setStateTarget] = useState(false);
  const handleClickTarget = () => {
    setStateTarget(true);
  };
  const handleCloseTarget = () => {
    setStateTarget(false);
  };

  const getTarget = () => {
    // setLoading(true);
    Api.get('gis/settings/get_target')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          setTargetPendataan(response.data[0].jml_target);
        }
      })
      .finally(function () {
        // setLoading(false);
      });
  };

  const onTarget = () => {
    // setLoading(true);
    Api.post('gis/settings/save_target', {
      targetPendataan,
    }).finally(function () {
      // setLoading(false);
      setDrawer(false);
      setCheckedPendataan(false);
      swal({
        title: 'Save Berhasil',
        text: null,
        icon: 'success',
        button: 'close',
      });
    });
  };

  //Pengaturan Zoom----------------------------------------------------------------------------------------------------
  const [validZoomKelurahan, setValidZoomKelurahan] = useState(null);
  const [validZoomBlok, setValidZoomBlok] = useState(null);
  const [validZoomPersil, setValidZoomPersil] = useState(null);

  const [stateZoom, setStateZoom] = useState(false);
  const handleClickZoom = () => {
    setStateZoom(true);
  };
  const handleCloseZoom = () => {
    setStateZoom(false);
  };

  const getZoom = () => {
    // setLoading(true);
    Api.get('gis/settings/get_zoom')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          setZoomKelurahan(response.data[0].kelurahan);
          setZoomBlok(response.data[0].blok);
          setZoomPersil(response.data[0].persil);
        }
      })
      .finally(function () {
        // setLoading(false);
      });
  };

  const onZoom = () => {
    // setLoading(true);
    Api.post('gis/settings/save_zoom', {
      zoomKelurahan,
      zoomBlok,
      zoomPersil,
    }).finally(function () {
      // setLoading(false);
      setDrawer(false);
      swal({
        title: 'Save Berhasil',
        text: null,
        icon: 'success',
        // button: 'close',
      });
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  //Pengaturan Warna----------------------------------------------------------------------------------------------------
  const [warna, setWarna] = useState(false);
  const handleClickWarna = () => {
    setWarna(true);
  };
  const handleCloseWarna = () => {
    setWarna(false);
  };

  const [listWarna, setListWarna] = useState([]);
  const getWarna = () => {
    // setLoading(true);
    Api.get('gis/settings/get_warna')
      .then(function (response) {
        if (response) {
          // console.log(response.data);
          setListWarna(response.data);
        }
      })
      .finally(function () {
        // setLoading(false);
      });
  };

  const onWarna = () => {
    // console.log(warna);
    // setLoading(true);
    Api.post('gis/settings/save_warna', {
      listWarna,
    }).finally(function () {
      // setLoading(false);
      setDrawer(false);
      setRefreshLegend((e) => !e);
      getKelurahan();
      swal({
        title: 'Save Berhasil',
        text: null,
        icon: 'success',
        button: 'close',
      });
    });
  };

  return [
    //Pbb
    {tahun, setTahun},
    {kecamatan, setKecamatan, kecamatanOptions, setKecamatanOptions, handleKecamatan, itemKecamatan},
    {kelurahan, setKelurahan, kelurahanOptions, setKelurahanOptions, handleKelurahan, itemKelurahan},
    {blok, setBlok, blokOptions, setBlokOptions, handleBlok, itemBlok},
    {znt, handleClickZnt, handleCloseZnt},
    {sebaranZnt, handleClickSebaranZnt, handleCloseSebaranZnt},
    {ketetapanPbb, handleClickKetetapanPbb, handleCloseKetetapanPbb},
    {statusPembayaran, handleClickStatusPembayaran, handleCloseStatusPembayaran},
    {
      onZnt,
      onDefault,
      onSebaranZnt,
      onKetetapanPbb,
      onObjekIndividu,
      onJenisTanah,
      onJenisBangunan,
      onKelasTanah,
      onKelasBangunan,
      onStatusPendaftaran,
      onStatusPembayaran,
      onStatusTunggakan,
      onPbb,
      onBphtb,
      onHotel,
      onRestoran,
      onHiburan,
      onReklame,
      onPpj,
      onMblb,
      onParkir,
      onPat,
      onWalet,
      onPendataan,
    },
    //Pencarian
    {cariNama, handleClickCariNama, handleCloseCariNama},
    {onCariNama, onCariNamaButton, handlePressCariNama, nama, setNama, listNama},
    {cariAlamat, handleClickCariAlamat, handleCloseCariAlamat},
    {onCariAlamat, onCariAlamatButton, handlePressCariAlamat, alamat, setAlamat, listAlamat},
    {cariBlok, handleClickCariBlok, handleCloseCariBlok, onResetBlok, onCariBlok},
    {cariKoordinat, handleClickCariKoordinat, handleCloseCariKoordinat, onResetKoordinat, onCariKoordinat},
    //Custom Maps
    {custom, handleClickCustom, handleCloseCustom},
    {onCustom},
    //dialog upload
    {uploadFoto, setUploadFoto, handleClickUploadFoto, handleCloseUploadFoto},
    {uploadKelurahan, setUploadKelurahan, handleClickUploadKelurahan, handleCloseUploadKelurahan},
    {uploadBlok, setUploadBlok, handleClickUploadBlok, handleCloseUploadBlok},
    {uploadPersil, setUploadPersil, handleClickUploadPersil, handleCloseUploadPersil},
    {uploadZnt, setUploadZnt, handleClickUploadZnt, handleCloseUploadZnt},
    //upload file GeoJSON
    {onUploadFoto},
    {
      shpKelurahan,
      shxKelurahan,
      dbfKelurahan,
      shpKelurahanHandler,
      shxKelurahanHandler,
      dbfKelurahanHandler,
      progressKelurahan,
      onUploadKelurahan,
    },
    {shpBlok, shxBlok, dbfBlok, shpBlokHandler, shxBlokHandler, dbfBlokHandler, progressBlok, onUploadBlok},
    {shpPersil, shxPersil, dbfPersil, shpPersilHandler, shxPersilHandler, dbfPersilHandler, progressPersil, onUploadPersil},
    {shpZnt, shxZnt, dbfZnt, shpZntHandler, shxZntHandler, dbfZntHandler, progressZnt, onUploadZnt},
    //others
    {onPrint},
    {onTitikPusat, stateTitik, setStateTitik, handleClickTitikPusat, handleCloseTitikPusat},
    {onTarget, stateTarget, setStateTarget, handleClickTarget, handleCloseTarget},
    {onZoom, stateZoom, setStateZoom, handleClickZoom, handleCloseZoom},
    {validZoomKelurahan, validZoomBlok, validZoomPersil, setValidZoomKelurahan, setValidZoomBlok, setValidZoomPersil},
    {listWarna, setListWarna, onWarna, warna, setWarna, handleClickWarna, handleCloseWarna},
  ];
};

export default useHook;
